import React, {useMemo, useCallback} from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";
import { useTextResources } from "../../../language";
import useBoolean from "../../../hooks/useBoolean";
import TokenExpirationCheckPopup from "../popups/TokenExpirationCheckPopup";

const GridMenu = ({
    taxIdentities,
    refreshData,
}) => {
    const text = useTextResources();
    const {
        value: isTokenExpirationCheckPopupOpen,
        setTrue: openTokenExpirationCheckPopup,
        setFalse: closeTokenExpirationPopup
    } = useBoolean(false);

    const taxIdentitiesToCheckTokenExpirationIds = useMemo(() => {
        return taxIdentities
            .filter(taxIdentity => !taxIdentity.TokenExpirationDate)
            .map(taxIdentity => taxIdentity.Id);
    }, [taxIdentities]);

    const handleTokenExpirationCheckPopupClose = useCallback(async () => {
        await refreshData();
        closeTokenExpirationPopup();
    }, [refreshData, closeTokenExpirationPopup]);

    return (
        <>
            <div>
                <Button size='small' onClick={openTokenExpirationCheckPopup}>
                    {text("RunTokenExpirationChecks")}
                </Button>
            </div>
            <TokenExpirationCheckPopup
                open={isTokenExpirationCheckPopupOpen}
                onClose={handleTokenExpirationCheckPopupClose}
                taxIdentityIds={taxIdentitiesToCheckTokenExpirationIds}
            />
        </>
    );
};

GridMenu.propTypes = {
    taxIdentities: PropTypes.arrayOf(PropTypes.shape({
        Id: PropTypes.number.isRequired,
        TokenCreateDate: PropTypes.object,
        TokenExpirationDate: PropTypes.object,
    })),
    refreshData: PropTypes.func.isRequired,
};

GridMenu.defaultProps = {
    taxIdentities: [],
};

export default GridMenu;
